export default function secondsToHour(seconds) {
  if (!seconds) return 0;
  return seconds / 3600;
}
